import { useCallback, memo } from 'react';
import { SkuDcReportGridData } from '@pages/reporting-pages/deliveries-sku-dc/types/SkuDcReportGridData';
import { renderKilogramsToTonnes, numberWithSpaces } from 'components/global/utils';
import CellPercentBar from 'components/cell-percent-bar/CellPercentBar';



interface GridRowProps {
	item: SkuDcReportGridData,
	rowIndex: number,
}
  

const GridRow = (props: GridRowProps) => {
	const { rowIndex } = props;
	const { executionPlaceName, country,
		total_volume, total_volumePct, total_weight, total_ordersCount,
		on_volume, on_volumePct, on_weight, on_ordersCount,
		off_volume, off_volumePct, off_weight, off_ordersCount } = props.item;

	const getClassName = useCallback((centered: boolean, leftAlign: boolean = false) => 
		`app-grid-cell${
			rowIndex % 2 == 0 ? ' secondary-cell' : ' primary-cell'
		}${
			leftAlign ? ' left-align-cell' : ''
		}${
			centered ? ' centered-cell' : ''
		}`
	,[ rowIndex ]);


	return (
		<>
			<div className={getClassName(true)}>
				<p>{country}</p>
			</div>

			<div className={getClassName(true)}>
				<p>{executionPlaceName}</p>
			</div>

			
			<CellPercentBar
				cellClassName={getClassName(true)}
				value={total_volume}
				percentValue={total_volumePct} />

			<div className={getClassName(true)}>
				<p>{renderKilogramsToTonnes(total_weight)}</p>
			</div>

			<div className={getClassName(true)}>
				<p>{numberWithSpaces(total_ordersCount)}</p>
			</div>


			<CellPercentBar
				cellClassName={getClassName(true)}
				value={on_volume}
				percentValue={on_volumePct} />

			<div className={getClassName(true)}>
				<p>{renderKilogramsToTonnes(on_weight)}</p>
			</div>

			<div className={getClassName(true)}>
				<p>{numberWithSpaces(on_ordersCount)}</p>
			</div>


			<CellPercentBar
				cellClassName={getClassName(true)}
				value={off_volume}
				percentValue={off_volumePct} />

			<div className={getClassName(true)}>
				<p>{renderKilogramsToTonnes(off_weight)}</p>
			</div>

			<div className={getClassName(true)}>
				<p>{numberWithSpaces(off_ordersCount)}</p>
			</div>
		</>
	)
}

export default memo(GridRow);